import { ProductsTableController } from './products-table.controller'

function productsTable () {
  return {
    restrict: 'E',
    scope: {
      products: '=',
      params: '=',
      getProducts: '<'
    },
    templateUrl: '/admin/directives/products-table/products-table.html?$$REVISION$$',
    controller: ProductsTableController
  }
}

export { productsTable }
